export default __webpack_public_path__ + "ede34fb30363f7c16a9ca60e23415e34.webp";